import { useRef, useState } from "react"
import moment from "moment"
import { Edit2, Save, X } from "react-feather"
import { useDispatch } from "react-redux"
import Editor from "react-simple-wysiwyg"
import { DayDDL, dayOptions } from "../../../CommonDDL/Day/DayDDL"
import { Asterisks } from "../../../Asterisks/Asterisks"
import { MeetingLinkRegex, RegExIsURLValid, RegExMeetingLink } from "../../../../helper/Regx"
import { useAuthState } from "../../../../helper/Context/context"
import { compressImageFile, getImageExtension, validateImageFile } from "../../../../helper/ImageValidation/ImageValidation"
import { POST_M_SeminarMaster_InsertAPI } from "../../../../helper/Redux/Slices/Admin/SeminarMasterSlice/SeminarMasterSlice"
import { LogoLoader } from "../../../../helper/Loaders/LogoLoader"

export const UpcomingSeminarPopup = ({ UpcomingSeminarData, cancelbtn, heading, setIsPost, IsPost }) => {
    const modalData = UpcomingSeminarData && UpcomingSeminarData.data
    const screenType = UpcomingSeminarData && UpcomingSeminarData.screenType
    const dispatch = useDispatch()
    const userDetails = useAuthState()
    const { UserID, token } = userDetails.user
    const [loader, setLoader] = useState(false)
    const dayFieldRef = useRef(null)
    const [DayID, setDayID] = useState({
        DDL: dayOptions,
        ID: modalData?.selectDay || modalData?.day || "",
        Label: modalData?.selectDay || modalData?.day || "Select day...",
    })

    const [formData, setFormData] = useState({
        title: modalData?.title || "",
        subTitle: modalData?.subTitle || "",
        date: modalData?.seminarDate ? moment(modalData.seminarDate).format("YYYY-MM-DD") : "",
        fromTime: modalData?.startTime ? moment(modalData.startTime, "HH:mm:ss").format("HH:mm") : "",
        toTime: modalData?.endTime ? moment(modalData.endTime, "HH:mm:ss").format("HH:mm") : "",
        description: modalData?.description || "",
        keyTopics: modalData?.keyTopics || "",
        fromDate: modalData?.fromDate ? moment(modalData.fromDate).format("YYYY-MM-DD") : "",
        toDate: modalData?.toDate ? moment(modalData.toDate).format("YYYY-MM-DD") : "",
        seminarPhoto: modalData?.seminarPhotoPath || "",
        sidePhoto: modalData?.sidePhotoPath || "",
        registerForSeminar: modalData?.registerLink || "",
        meetingLink: modalData?.meetingLink || "",
    })
    const [seminarPhotoPreview, setSeminarPhotoPreview] = useState(modalData?.seminarPhotoPath || "")
    const [sidePhotoPreview, setSidePhotoPreview] = useState(modalData?.sidePhotoPath || "")
    const [imageLoading, setImageLoading] = useState("")
    const [photoError, setPhotoError] = useState("")
    const [dayError, setDayError] = useState("")
    const [registerLinkError, setRegisterLinkError] = useState("")
    const [meetingLinkError, setMeetingLinkError] = useState("")

    const handleDayChange = (value) => {
        setDayID(value)
        setDayError(value.ID ? "" : "Please select a day.")
    }

    const handleChange = (event) => {
        const { name, value } = event.target
        setFormData({ ...formData, [name]: value })

        // if (name === "meetingLink") {
        //     setMeetingLinkError(
        //         RegExMeetingLink(value)
        //             ? "Please enter a valid Google Meet, Zoom, or Microsoft Teams link."
        //             : ""
        //     )
        // }

        // if (name === "registerForSeminar") {
        //     setRegisterLinkError(
        //         RegExIsURLValid(value)
        //             ? "Please enter a valid registration link."
        //             : ""
        //     )
        // }
    }

    const handlePhotoChange = async (event, name) => {
        const file = event.target.files[0]
        if (file) {
            const imageError = validateImageFile(file, { allowCompression: true })
            if (imageError) {
                setPhotoError(imageError)
                event.target.value = ""
                return
            }

            try {
                setImageLoading(name)
                const compressedFile = await compressImageFile(file)
                setFormData({ ...formData, [name]: compressedFile })
                setPhotoError("")
                if (name === "seminarPhoto") {
                    setSeminarPhotoPreview(URL.createObjectURL(compressedFile))
                }
                if (name === "sidePhoto") {
                    setSidePhotoPreview(URL.createObjectURL(compressedFile))
                }
            } catch (error) {
                setPhotoError(error.message)
            } finally {
                setImageLoading("")
            }
        }
        event.target.value = ""
    }

    const handleRemovePhoto = (name) => {
        setFormData({ ...formData, [name]: "" })
        if (name === "seminarPhoto") {
            setSeminarPhotoPreview("")
        }
        if (name === "sidePhoto") {
            setSidePhotoPreview("")
        }
    }

    // Shows file name for a new file or for a saved image path
    const getFileName = (photo) => {
        if (!photo) return ""
        if (typeof photo === "string") return photo.split("/").pop()
        return photo.name
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        if (!DayID.ID) {
            setDayError("Please select a day.")
            dayFieldRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
            return
        }

        // if (RegExIsURLValid(formData.registerForSeminar)) {
        //     setRegisterLinkError("Please enter a valid registration link.")
        //     return
        // }

        // if (RegExMeetingLink(formData.meetingLink)) {
        //     setMeetingLinkError("Please enter a valid Google Meet, Zoom, or Microsoft Teams link.")
        //     return
        // }

        if (!formData.seminarPhoto) {
            setPhotoError("Please upload a seminar photo.")
            return
        }

        setLoader(true)

        const handleIsPost = () => {
            // setIsPost((value) => !value)
            // cancelbtn()
            setIsPost(!IsPost)
            cancelbtn()
        }

        const data = {
            SeminarID: modalData?.seminarID || 0,
            Title: formData.title,
            SubTitle: formData.subTitle,
            SelectDay: DayID.ID,
            SeminarDate: formData.date,
            StartTime: formData.fromTime,
            EndTime: formData.toTime,
            Description: formData.description,
            KeyTopics: formData.keyTopics,
            FromDate: formData.fromDate,
            ToDate: formData.toDate,
            SeminarPhotoPath: formData.seminarPhoto,
            SeminarPhotoExt: getImageExtension(formData.seminarPhoto),
            SidePhotoPath: formData.sidePhoto,
            SidePhotoExt: getImageExtension(formData.sidePhoto),
            RegisterLink: formData.registerForSeminar,
            MeetingLink: formData.meetingLink,
            M_UserID: UserID,
            token: token,
            handleIsPost,
            setloader: setLoader,
            ScreenType: screenType === "edit" ? "Update" : "Insert",
        }

        dispatch(POST_M_SeminarMaster_InsertAPI({ data }))
    }

    return (
        <div className="seminar-backdrop custom">
            <div className="modal-dialog modal-dialog-centered seminar-dialog">
                <div className="modal-content seminar-content">
                    <form onSubmit={handleSubmit} className="seminar-form">

                        {/* Header */}
                        <div className="d-flex align-items-center justify-content-between seminar-header">
                            <h6 className="m-0 fw-bold">
                                {(screenType === "edit" ? "Update Seminar" : "Add Seminar")}
                            </h6>
                            {/* <button type="button" className="btn btn-link text-white p-0 seminar-close" onClick={cancelbtn} aria-label="Close seminar form">
                                <X size={18} />
                            </button> */}
                            <button type="button" className="btn-close btn-close-white seminar-close" onClick={cancelbtn} aria-label="Close" />
                        </div>

                        {/* Body */}
                        {loader && <LogoLoader />}
                        <div className="seminar-body">
                            <div className="row g-3">
                                <div className="col-12">
                                    <label htmlFor="seminarTitle" className="seminar-label">Title of Seminar <Asterisks /></label>
                                    <input
                                        id="seminarTitle"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        className="form-control seminar-control"
                                        required
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="seminarSubTitle" className="seminar-label">Sub Title of Seminar <Asterisks /></label>
                                    <input
                                        id="seminarSubTitle"
                                        name="subTitle"
                                        value={formData.subTitle}
                                        onChange={handleChange}
                                        className="form-control seminar-control"
                                        required
                                    />
                                </div>

                                <div className="col-6" ref={dayFieldRef}>
                                    <label htmlFor="seminarDay" className="seminar-label">Select Day <Asterisks /></label>
                                    <DayDDL DayID={DayID} setDayID={handleDayChange} />
                                    {dayError && <div className="seminar-error" role="alert">{dayError}</div>}
                                </div>
                                <div className="col-6">
                                    <label htmlFor="seminarDate" className="seminar-label">Date <Asterisks /></label>
                                    <input
                                        id="seminarDate"
                                        name="date"
                                        type="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                        className="form-control seminar-control"
                                        required
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="seminarFromTime" className="seminar-label">Time <Asterisks /></label>
                                    <div className="d-flex align-items-center gap-2">
                                        <input id="seminarFromTime"
                                            name="fromTime"
                                            type="time"
                                            value={formData.fromTime}
                                            onChange={handleChange}
                                            className="form-control seminar-control"
                                            required
                                        />
                                        <span className="seminar-to-text">to</span>
                                        <input
                                            name="toTime"
                                            type="time"
                                            value={formData.toTime}
                                            onChange={handleChange}
                                            className="form-control seminar-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="seminarDescription" className="seminar-label">Description <Asterisks /></label>
                                    <textarea
                                        id="seminarDescription"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        className="form-control seminar-control webinar-textarea"
                                        rows="3"
                                        required
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="seminarKeyTopics" className="seminar-label">Key Topics <Asterisks /></label>
                                    {/* <textarea
                                        id="seminarKeyTopics"
                                        name="keyTopics"
                                        value={formData.keyTopics}
                                        onChange={handleChange}
                                        className="form-control seminar-control webinar-textarea"
                                        rows="3"
                                        required
                                    /> */}
                                    <Editor
                                        id="seminarKeyTopics"
                                        name="keyTopics"
                                        value={formData.keyTopics}
                                        onChange={handleChange}
                                        containerProps={{ style: { resize: "vertical" } }}
                                    />
                                </div>

                                <div className="col-6">
                                    <label htmlFor="seminarFromDate" className="seminar-label">From Date <Asterisks /></label>
                                    <input
                                        id="seminarFromDate"
                                        name="fromDate"
                                        type="date"
                                        value={formData.fromDate}
                                        onChange={handleChange}
                                        className="form-control seminar-control"
                                        required
                                    />
                                </div>
                                <div className="col-6">
                                    <label htmlFor="seminarToDate" className="seminar-label">To Date <Asterisks /></label>
                                    <input
                                        id="seminarToDate"
                                        name="toDate"
                                        type="date"
                                        min={formData.fromDate}
                                        value={formData.toDate}
                                        onChange={handleChange}
                                        className="form-control seminar-control"
                                        required
                                    />
                                </div>

                                {/* Seminar photo */}
                                <div className="col-6 seminar-photo-col">
                                    <label className="seminar-label">Seminar Photo Upload <Asterisks /></label>
                                    <div className={photoError ? "seminar-upload-box is-error" : "seminar-upload-box"}>
                                        <label className="btn btn-outline-primary seminar-choose-btn">
                                            Choose Image
                                            <input type="file" accept="image/*" hidden disabled={Boolean(imageLoading)} onChange={(event) => handlePhotoChange(event, "seminarPhoto")} />
                                        </label>
                                        <div className="seminar-upload-hint">JPG or PNG - Max 2 MB</div>
                                        {imageLoading === "seminarPhoto" && (
                                            <div className="d-flex align-items-center gap-2 text-primary mb-2" role="status" aria-live="polite">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true" />
                                                Loading image...
                                            </div>
                                        )}

                                        {seminarPhotoPreview && <img src={seminarPhotoPreview} alt="Seminar preview" loading="lazy" decoding="async" className="seminar-preview mb-2" />}

                                        {formData.seminarPhoto && (
                                            <div>
                                                <span className="seminar-file-chip">{getFileName(formData.seminarPhoto)}</span>
                                                <button type="button" className="seminar-remove-link"
                                                    onClick={() => handleRemovePhoto("seminarPhoto")}>
                                                    Remove
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    {photoError && <div className="seminar-error">{photoError}</div>}
                                </div>

                                {/* Side photo */}
                                <div className="col-6 seminar-photo-col">
                                    <label className="seminar-label">Side Photo Upload</label>
                                    <div className="seminar-upload-box">
                                        <label className="btn btn-outline-primary seminar-choose-btn">
                                            Choose Image
                                            <input type="file" accept="image/*" hidden disabled={Boolean(imageLoading)} onChange={(event) => handlePhotoChange(event, "sidePhoto")} />
                                        </label>
                                        <div className="seminar-upload-hint">JPG or PNG - Max 2 MB</div>
                                        {imageLoading === "sidePhoto" && (
                                            <div className="d-flex align-items-center gap-2 text-primary mb-2" role="status" aria-live="polite">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true" />
                                                Loading image...
                                            </div>
                                        )}

                                        {sidePhotoPreview && <img src={sidePhotoPreview} alt="Side preview" loading="lazy" decoding="async" className="seminar-preview mb-2" />}

                                        {formData.sidePhoto && (
                                            <div>
                                                <span className="seminar-file-chip">{getFileName(formData.sidePhoto)}</span>
                                                <button type="button" className="seminar-remove-link"
                                                    onClick={() => handleRemovePhoto("sidePhoto")}>
                                                    Remove
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="seminarRegistration" className="seminar-label">Register link for Seminar</label>
                                    <input
                                        id="seminarRegistration"
                                        name="registerForSeminar"
                                        type="url"
                                        value={formData.registerForSeminar}
                                        onChange={handleChange}
                                        className={`form-control seminar-control${registerLinkError ? " is-invalid" : ""}`}
                                        aria-invalid={Boolean(registerLinkError)}
                                    />
                                    {registerLinkError && <div className="seminar-error" role="alert">{registerLinkError}</div>}
                                </div>

                                <div className="col-12">
                                    <label htmlFor="seminarMeetingLink" className="seminar-label">Meeting Link</label>
                                    <input
                                        id="seminarMeetingLink"
                                        name="meetingLink"
                                        type="url"
                                        pattern={MeetingLinkRegex.source}
                                        value={formData.meetingLink}
                                        onChange={handleChange}
                                        className={`form-control seminar-control${meetingLinkError ? " is-invalid" : ""}`}
                                        aria-invalid={Boolean(meetingLinkError)}
                                    />
                                    {meetingLinkError && <div className="seminar-error" role="alert">{meetingLinkError}</div>}
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="d-flex justify-content-end gap-2 seminar-footer">
                            <button type="button" className="btn btn-danger seminar-btn-cancel"
                                disabled={loader}
                                onClick={cancelbtn}>
                                <X size={15} className="me-1" />
                                Cancel
                            </button>

                            <button type="submit" className="btn btn-primary seminar-btn-primary" disabled={loader}>
                                {screenType === "edit" ? (
                                    <>
                                        <Edit2 size={15} className="me-1" />
                                        Update
                                    </>
                                ) : (
                                    <>
                                        <Save size={15} className="me-1" />
                                        Save
                                    </>
                                )}
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    )
}